import { useKnowledgeDocumentDataContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentDataContext'
import { useKnowledgeDocumentUXContext } from 'features/knowledgeDocumentViewer/contexts/KnowledgeDocumentUXContext'
import { useMemo } from 'react'
import { BoundingBoxJsonItem } from 'types'

export type OcrResultWithPage = BoundingBoxJsonItem & {
  pageNumber: number
  confirmed: boolean
}

export const useOcrResults = () => {
  const { currentDocumentQuery, assetTypeFilters } =
    useKnowledgeDocumentUXContext()
  const { selectedDocumentOcrEntries } = useKnowledgeDocumentDataContext()

  const allOcrResults = useMemo<OcrResultWithPage[]>(() => {
    const allPages = selectedDocumentOcrEntries?.[0]?.entry.data?.pages ?? []

    return allPages.flatMap((page) => [
      ...page.confirmed.map((box) => ({
        ...box,
        pageNumber: page.pageNumber,
        confirmed: true,
      })),
      ...page.unconfirmed.map((box) => ({
        ...box,
        pageNumber: page.pageNumber,
        confirmed: false,
      })),
    ])
  }, [selectedDocumentOcrEntries])

  const filteredOcrResults = useMemo(() => {
    let results = allOcrResults

    if (assetTypeFilters.length > 0) {
      results = results.filter(
        (box) => box.type && assetTypeFilters.includes(box.type)
      )
    }

    if (currentDocumentQuery.trim() !== '') {
      const searchLower = currentDocumentQuery.toLowerCase()
      results = results.filter((box) =>
        box.text?.toLowerCase().includes(searchLower)
      )
    }

    return results
  }, [allOcrResults, assetTypeFilters, currentDocumentQuery])

  return {
    allOcrResults,
    filteredOcrResults,
  }
}
